import gql from 'graphql-tag';

export default gql`
mutation ($etlQueries: [UpdateEtlQueryInput]) {
    updateBatchEtlQuery (etlQueries: $etlQueries) {
        __typename        
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlQueries/UpdateBatchMutation.js